import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEnglish from "./languages/english.json";
import translationFrench from "./languages/french.json";
import translationPortuguese from "./languages/portuguese.json"


const resources = {
    1: {
        translation: translationEnglish
    },
    2: {
        translation: translationFrench
    },
    3: {
        translation: translationPortuguese
    },
    4: {
        translation: translationEnglish
    },
    en: {
        translation: translationEnglish
    },
    fr: {
        translation: translationFrench
    },
    pt: {
        translation: translationPortuguese
    }
};

const getInitialLanguage = () => {
    if (typeof window !== "undefined") {
        const saved = localStorage.getItem("user_selected_language");
        if (saved) return String(saved);
    }
    return "2"; // Default to French
};

i18n.use(initReactI18next).init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: "2",
    interpolation: {
        escapeValue: false // react already escapes values
    }
});

export default i18n;
